import { Component } from '@angular/core';
import { RouterLink, RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DashboardService } from '../../_services/dashboard/dashboard.service';
import { ToastService } from '../../_services/toast.service';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-contactus',
  imports: [CommonModule,FormsModule,ReactiveFormsModule, RouterLink, RouterModule],
  templateUrl: './contactus.component.html',
  styleUrl: './contactus.component.scss'
})
export class ContactusComponent {
  contactForm!: FormGroup;
    faqs: FaqItem[] = [
    {
      question: 'What is Circled Plus?',
      answer:
        'Circled Plus is an invite-only platform for curated luxury homes. We feature a set of premium residences that meet strict criteria on location, design, privacy, and long-term value, homes that are typically not found on public listing portals.'
    },
    {
      question: 'Why is there a ₹3,000 premium subscription fee?',
      answer:
        'The premium subscription is designed to offer a guided, high-touch experience rather than a self-serve property portal. As a member, you receive unlimited access to Circled Plus’ curated luxury listings and are assigned a dedicated sales manager who helps you shortlist relevant homes, coordinates property visits and private previews, and manages communication with owners or developers on your behalf. This ensures a focused, discreet, and efficient search experience while maintaining the quality, privacy, and seriousness for which Circled Plus is built.'
    },
    {
      question: 'Is the subscription refundable or adjustable?',
      answer:
        'The subscription fee is non-refundable. However, it gives you access to multiple curated listings, private previews, and advisory support during the validity period, making it significantly more valuable than a single listing fee.'
    },
    {
      question: 'Is my data safe on Circled Plus?',
      answer:
        'Yes. Your personal information is kept private and used only to provide a better, more relevant experience on Circled Plus. We do not sell, share, or publicly display your data. Access to your details is strictly limited to our internal team and your assigned relationship manager, ensuring discretion, confidentiality, and responsible handling at every stage of your property search.'
    },
    {
      question: 'Can I book property visits through Circled Plus?',
      answer:
        'Yes. Once you shortlist a property, your assigned sales manager will coordinate the visit, align schedules, and handle communication with owners or developers. This removes the need for multiple follow-ups and ensures a smooth, well-organised viewing experience.'
    }
  ];

  activeIndex: number | null = 0;
  isSubmitting = false;
  showSuccessPopup = false;
  countryCodes = [

    // India
    { flag: '🇮🇳', code: '+91' },

    // USA / Canada
    { flag: '🇺🇸', code: '+1' },
    { flag: '🇨🇦', code: '+1' },

    // UK & Europe
    { flag: '🇬🇧', code: '+44' },
    { flag: '🇩🇪', code: '+49' },
    { flag: '🇫🇷', code: '+33' },
    { flag: '🇳🇱', code: '+31' },
    { flag: '🇨🇭', code: '+41' },
    { flag: '🇮🇹', code: '+39' },
    { flag: '🇪🇸', code: '+34' },
    { flag: '🇸🇪', code: '+46' },
    { flag: '🇳🇴', code: '+47' },

    // Middle East
    { flag: '🇦🇪', code: '+971' },
    { flag: '🇸🇦', code: '+966' },
    { flag: '🇶🇦', code: '+974' },
    { flag: '🇰🇼', code: '+965' },
    { flag: '🇴🇲', code: '+968' },
    { flag: '🇧🇭', code: '+973' },

    // Asia
    { flag: '🇸🇬', code: '+65' },
    { flag: '🇭🇰', code: '+852' },
    { flag: '🇲🇾', code: '+60' },
    { flag: '🇹🇭', code: '+66' },
    { flag: '🇯🇵', code: '+81' },

    // Australia / NZ
    { flag: '🇦🇺', code: '+61' },
    { flag: '🇳🇿', code: '+64' },

    // Africa
    { flag: '🇿🇦', code: '+27' }

  ];
  constructor(private fb: FormBuilder,private _DS: DashboardService,private _NS:ToastService ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({

      name: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(/^[a-zA-Z\s]+$/)
      ]],

      email: ['', [
        Validators.required,
        Validators.email
      ]],

      countryCode: ['+91', Validators.required],

      phone: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{6,15}$/)
      ]],

      message: ['', [
        Validators.required,
        Validators.minLength(10)
      ]]

    });
  }

  get f() {
    return this.contactForm.controls;
  }

  toggle(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
  // onSubmit(): void {
  //   if (this.contactForm.invalid) {
  //     this.contactForm.markAllAsTouched();
  //     return;
  //   }
  //   const payload = {
  //     ...this.contactForm.value,
  //     phone: `+91${this.contactForm.value.phone}`,
  //   };
  //   this._DS.contactUsNotifiction(payload).subscribe({
  //     next: () => {
  //       this.contactForm.reset();
  //       this._NS.success('Request has been submitted')
        
  //     },
  //     error: (err) => {
  //       this._NS.error('Something went wrong!')
  //     }
  //   });
  // }

  onSubmit(): void {

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const payload = {
      ...this.contactForm.value,
      phone: `${this.contactForm.value.countryCode}${this.contactForm.value.phone}`
    };

    this._DS.contactUsNotifiction(payload).subscribe({

      next: () => {

        this.isSubmitting = false;

        this.contactForm.reset({
          countryCode: '+91'
        });

        this.showSuccessPopup = true;

      },

      error: () => {

        this.isSubmitting = false;

        this._NS.error('Something went wrong!');

      }

    });
  }
  closeSuccessPopup(): void {

    this.showSuccessPopup = false;

    this.contactForm.reset({
      countryCode: '+91'
    });

  }
}
